'use client'

import { useApi } from '@repo/api'
import { useSuspenseQuery } from '@repo/tanstack/query'

export const useSuspenseGetSearchCompanies = (query: string, orgIdOverride?: number) => {
  const api = useApi()

  return useSuspenseQuery(
    api.companies.search.queryOptions({
      input: {
        org_id: orgIdOverride,
        perPage: 20,
        search: query,
      },
    }),
  )
}
